import commonData from "../data/localization.yml";

export const pickByRegion = (regionsObject, regionCode, fallback = "EN") => {
  if (!regionsObject) return {};
  return regionsObject[regionCode] || regionsObject[fallback] || {};
};

export const getCommonData = (regionCode) => {
  if (commonData?.regions) {
    return pickByRegion(commonData.regions, regionCode);
  }
  return {};
};
